import AppDispatcher from "../Dispatcher";
import AppSDK from "@growthos/ui-app-sdk";
import { AppActionConstants } from "./AppActionConstants";
import AppConfig from "../../AppConfig";
import { fetchWithAuthGet, fetchWithAuthPost } from "../FetchWithAuth";
import BookFiltersStore from "../Stores/BookFiltersStore";

const basePath = AppConfig.getBookApiBasePath();

export const fetchCreatives = (config, campaignUniqueID) => {
	const contextValues = BookFiltersStore.getContextValues();
	return Promise.all([
		fetchWithAuthGet(
			`${basePath.ApiBasePath}/plook/TaxonomyConfiguration/getHeaders/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}`
		),
		fetchWithAuthGet(
			`${basePath.ApiBasePath}/plook/Campaign/getalllineitems/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}/${campaignUniqueID}`
		)
	]).then((response) => {
		const config = response[0];
		const data = response[1];
		// do something with both responses
		const creativesData = {
			config,
			data
		};
		AppDispatcher.dispatch({
			type: AppActionConstants.fetchCreatives, // "FETCHCREATIVES"
			value: creativesData
		});
	});
};

export const updateCreativesSheet = (data) => {
	const user = AppSDK.ApiUser.getUser();
	data.FirstName = user?.givenName;
	data.LastName = user?.familyName;
	data.Email = user?.userName;

	const postData = JSON.stringify(data);
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/Creative/InsertUpdateCreatives`, postData);
};

export const putCreatives = (data, closeModal) => {
	/* API ENDPOINT /Book2API/custom/InsertMasterCampaign */

	const user = AppSDK.ApiUser.getUser();
	data.FirstName = user?.givenName;
	data.LastName = user?.familyName;
	data.Email = user?.userName;

	const postData = JSON.stringify(data);
	let type = AppActionConstants.updateCreativesSuccess;
	if (closeModal === false) {
		type = AppActionConstants.createAndAddCreativeSuccess;
	}
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/Creative/InsertUpdateCreatives`, postData)
		.then((resp) => {
			AppDispatcher.dispatch({
				type, // "UPDATECREATIVESSUCCESS or CREATEANDADDCREATIVESUCCESS"
				value: resp[1].Object
			});
		})
		.catch(async (error) => {
			const errorObject = await error.details.json();
			AppDispatcher.dispatch({
				type: AppActionConstants.updateCreativesFail, // "UPDATECREATIVESFAIL"
				value: errorObject[1].Object
			});
		});
};

export const editCreatives = (data) => {
	/* API ENDPOINT /Book2API/custom/InsertMasterCampaign */

	const user = AppSDK.ApiUser.getUser();
	data.FirstName = user?.givenName;
	data.LastName = user?.familyName;
	data.Email = user?.userName;

	const postData = JSON.stringify(data);
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/Creative/InsertUpdateCreatives`, postData)
		.then((resp) => {
			AppDispatcher.dispatch({
				type: AppActionConstants.editCreativesSuccess, // "EDITCREATIVESSUCCESS"
				value: resp?.[data?.[0]?.CreativeData?.UniqueID]?.Object || null
			});
		})
		.catch(async (error) => {
			const errorObject = await error.details.json();
			AppDispatcher.dispatch({
				type: AppActionConstants.editCreativesFail, // "EDITCREATIVESFAIL"
				value: errorObject?.[1]?.Object || Object.values(errorObject || {})?.[0]?.Object || {}
			});
		});
};
